module.exports = __webpack_public_path__ + "assets/b7a1d5befa321815d84360b9c658aaf4.svg";